import React, { PropsWithChildren } from 'react';

interface TenantMappingsContextValue {
  merchant: string;
  account: string;
  defaultCartTypeId: string;
}

const TenantMappingsContext = React.createContext<TenantMappingsContextValue | undefined>(
  undefined
);

export type TenantMappingsProviderProps = PropsWithChildren<TenantMappingsContextValue>;

export const TenantMappingsProvider: React.FC<TenantMappingsProviderProps> = ({
  merchant,
  account,
  defaultCartTypeId,
  children,
}) => {
  return (
    <TenantMappingsContext.Provider value={{ merchant, account, defaultCartTypeId }}>
      {children}
    </TenantMappingsContext.Provider>
  );
};

export const useTenantMappings = (): TenantMappingsContextValue => {
  const context = React.useContext(TenantMappingsContext);
  if (!context) {
    throw new Error('useTenantMappings must be used within a TenantMappingsProvider');
  }
  return context;
};
